/*
    Core store module getters

*/

import * as temp from "./temp";

export default {
  ...temp
}
